import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROLE_ROUTES } from '../utils/constants';
import LandingPage from '../pages/public/LandingPage';

const RoleRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  if (!user) {
    return <LandingPage />;
  }

  if (user.role === 'staff') {
    return <Navigate to="/staff/home" replace />;
  }

  return <Navigate to={ROLE_ROUTES[user.role] || '/login'} replace />;
};

export default RoleRedirect;
